"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _svg = _interopRequireDefault(require("../svg"));

var _footer = require("./footer.styles");

var _footerSections = require("./footer-sections");

var _gridContainer = require("../grid-container");

var _Footer$defaultProps;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Footer = function Footer(_ref) {
  var globalFooterContact = _ref.globalFooterContact,
      globalFooterLegal = _ref.globalFooterLegal,
      globalFooterLinks = _ref.globalFooterLinks,
      globalFooterLogo = _ref.globalFooterLogo,
      globalFooterSales = _ref.globalFooterSales,
      globalFooterSignature = _ref.globalFooterSignature,
      globalFooterSocialRebrand = _ref.globalFooterSocialRebrand;
  // Notes:
  // privacy policy is still served from ecomm-core, so don't attempt to use react-isomorphic-link
  return /*#__PURE__*/_react["default"].createElement(_gridContainer.GridContainer, {
    variant: "full",
    as: "footer"
  }, /*#__PURE__*/_react["default"].createElement(_footer.Wrapper, {
    variant: "body"
  }, /*#__PURE__*/_react["default"].createElement(_footer.LinkWrapper, null, /*#__PURE__*/_react["default"].createElement(_footerSections.LinkGrouping, {
    content: globalFooterLinks
  }), /*#__PURE__*/_react["default"].createElement(_footer.Grouping, null, /*#__PURE__*/_react["default"].createElement(_footerSections.ContactSection, {
    content: globalFooterContact
  }), /*#__PURE__*/_react["default"].createElement(_footer.Sales, null, /*#__PURE__*/_react["default"].createElement(_footerSections.ContactSection, {
    content: globalFooterSales
  }))), /*#__PURE__*/_react["default"].createElement(_footerSections.SocialSection, {
    content: globalFooterSocialRebrand
  })), /*#__PURE__*/_react["default"].createElement(_footer.AdditionalInfoWrapper, null, /*#__PURE__*/_react["default"].createElement(_footer.LogoRow, null, globalFooterLogo ? /*#__PURE__*/_react["default"].createElement(_svg["default"], {
    id: "glowforge-logo",
    height: "37px",
    noWidth: true,
    stroke: "transparent"
  }) : null, /*#__PURE__*/_react["default"].createElement(_footer.LoveWrapper, {
    sections: (globalFooterSignature === null || globalFooterSignature === void 0 ? void 0 : globalFooterSignature.listItems) || []
  })), /*#__PURE__*/_react["default"].createElement(_footerSections.LegalSection, {
    content: globalFooterLegal
  }))));
};

Footer.propTypes = {
  // Contentful driven props -
  //    Footer is populated from the raw contentful `global-footer`
  //    section data
  globalFooterContact: _propTypes["default"].objectOf(_propTypes["default"].any),
  globalFooterLegal: _propTypes["default"].objectOf(_propTypes["default"].any),
  // globalFooterLinks: extracted from fields.content[{fields: {title, listItems}}]
  //  into fields.content[{title, items}] for only link items.
  //  This eventually gets applied as the grouped links for the left-side sitemap under
  //  .marketing > .links
  globalFooterLinks: _propTypes["default"].arrayOf(_propTypes["default"].any),
  // globalFooterLogo: extracted from an entry in fields.content that has
  //   fields.id: 'glowforge-footer-logo', with the value from fields.svgAsset.
  //   Used in the companyInfo logo div
  globalFooterLogo: _propTypes["default"].objectOf(_propTypes["default"].any),
  globalFooterSales: _propTypes["default"].objectOf(_propTypes["default"].any),
  globalFooterSignature: _propTypes["default"].objectOf(_propTypes["default"].any),
  globalFooterSocialRebrand: _propTypes["default"].objectOf(_propTypes["default"].any)
};
Footer.defaultProps = (_Footer$defaultProps = {
  // Requiring any props that we plan to have from contentful is unhelpful
  // If there is an issue with that one part, then it'll break then entire
  // page looking for the required props
  globalFooterContact: null,
  globalFooterLegal: null,
  globalFooterLinks: null,
  globalFooterLogo: null,
  globalFooterSales: null,
  globalFooterSignature: null
}, _defineProperty(_Footer$defaultProps, "globalFooterSignature", null), _defineProperty(_Footer$defaultProps, "globalFooterSocialRebrand", null), _Footer$defaultProps);
var _default = Footer;
exports["default"] = _default;